import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import {
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogTitle,
  Typography,
  Snackbar,
  Alert,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ImageTemplateBlue from "../../components/JournalImageTemplate/ImageTemplate/ImageTemplateBlue";
import ImageTemplateCyan from "../../components/JournalImageTemplate/ImageTemplate/ImageTemplateCyan";
import ImageTemplatePink from "../../components/JournalImageTemplate/ImageTemplate/ImageTemplatePink";
import PreDefineTemplate1 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate1";
import PreDefineTemplate2 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate2";
import PreDefineTemplate3 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate3";
import PreDefineTemplate4 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate4";
import PreDefineTemplate5 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate5";
import PreDefineTemplate6 from "../../components/JournalImageTemplate/PreDesinedTemplate/PreDesinedTemplate6";
import TextTemplateBlue from "../../components/JournalImageTemplate/TextTemplate/TextTemplateBlue";
import TextTemplateCyan from "../../components/JournalImageTemplate/TextTemplate/TextTemplateCyan";
import TextTemplateWhite from "../../components/JournalImageTemplate/TextTemplate/TextTemplateWhite";
import VideoTemplateBlue from "../../components/JournalImageTemplate/VideoTemplate/VideoTemplateBlue";

import { useNotification } from "../../hooks/useNotification.js";
import { JournalAPIService } from "../../services/api/JournalAPIService";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE } from "../../shared/constants";
import dragIcon from "../../assests/Images/drag1.svg";
import bundle from "../../assests/Images/bundle.png";
import "./journal.css";
import FloatingActionMenu from "../Extra/FloatingActionMenu.js";
import html2canvas from "html2canvas";
import { toPng } from "html-to-image";
import VideoWithTransitions from "../Extra/video.js";
import { Checkbox, Paper } from "@mui/material";
import { isRealSafari } from "../../shared/utils.js";
import DownloadBackdrop from "./DownloadBackdrop.js";
import info from "../../assests/Images/info.png";
import info1 from "../../assests/Images/info1.png";
import info2 from "../../assests/Images/info2.png";
import info3 from "../../assests/Images/info3.png";

import { FFmpeg } from "@ffmpeg/ffmpeg";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const ffmpeg = new FFmpeg();

// Sortable Card Wrapper
function SortableItem({ id, children, video, reel }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    border: isDragging ? "2px dashed #1976d2" : "1px solid #fff",
    borderRadius: 4,
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };

  return (
    <Box
      ref={setNodeRef}
      {...attributes} // DO NOT spread listeners here
      sx={{
        ...style,
        flex: {
          xs: "1 0 calc(50% - 8px)",
          sm: "1 0 calc(50% - 8px)",
          md: "1 0 calc(33.33% - 8px)",
          lg: "1 0 calc(25% - 8px)",
        },
        maxWidth: {
          xs: "calc(50% - 8px)",
          sm: "calc(50% - 8px)",
          md: "calc(33.33% - 8px)",
          lg: "calc(25% - 8px)",
        },
        m: "4px",
        position: "relative",
      }}
    >
      {/* Drag Handle */}
      <Box
        // {...listeners}
        sx={{
          position: "absolute",
          top: 44,
          // left: 10,
          // right:12,
          cursor: "grab",
          zIndex: 1001,
          // background:"#ffffffc9",
          padding: "4px 0px 0px 4px",
          // borderRadius:"50%",
          height: "3px",
          width: "1%",
          "@media (max-width: 440px)": {
            height: "2px",
            width: "1%",
            left: 15,
            top: 40,
          },
          touchAction: "none",
        }}
      >
        {/* <img src={dragIcon} alt="drag" className="drag-icon" /> */}
      </Box>

      {isDragging && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2000,
            // backgroundColor: "rgba(255, 255, 255, 0.7)",
            // borderRadius: "50%",
            // padding: 2,
            // boxShadow: 3,
          }}
        >
          <img src={dragIcon} alt="drag" className="drag-icon" />
          {/* <DragIndicatorIcon fontSize="large" color="primary" /> */}
        </Box>
      )}

      {children}
    </Box>
  );
}

function MemorySelector({ data, user_phone, onClose, downloadJournal }) {
  const { phoneNumber: phone } = useParams();
  const { notifyError, notifySuccess } = useNotification();

  // const [data, setData] = useState(data);
  const [sequenceData, setSequenceData] = useState([]);
  const [sequenceCreation, setSequenceCreation] = useState(false);
  const [sequenceId, setSequenceId] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadLoadingFlag, setDownloadLoadingFlag] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const templateRefs = useRef({});
  const pageSize = 100;
  const [selectedTemplates, setSelectedTemplates] = useState({});
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [videoImageFiles, setVideoImageFiles] = useState([]);

  const observer = useRef();

  useEffect(() => {
    if (downloadJournal) {
      // Auto-select all templates if downloadJournal is true
      const selectedAll = data.reduce((acc, template) => {
        acc[template.id] = true;
        return acc;
      }, {});
      setSelectedTemplates(selectedAll);
    } else {
      // Clear selections if manual mode
      setSelectedTemplates({});
    }
  }, [downloadJournal, data]);

  const pageRefresh = () => {
    setPage(1);
  };

  const renderTemplateComponent = (template, index) => {
    const textTemplates = [
      TextTemplateBlue,
      TextTemplateWhite,
      TextTemplateCyan,
    ];
    const imageTemplates = [
      ImageTemplateBlue,
      ImageTemplatePink,
      ImageTemplateCyan,
    ];
    const videoTemplates = [VideoTemplateBlue];
    const ref = React.createRef();
    templateRefs.current[template.id] = ref;

    if (template.uploaded_by === "system") {
      const preDefined = [
        PreDefineTemplate1,
        PreDefineTemplate2,
        PreDefineTemplate3,
        PreDefineTemplate4,
        PreDefineTemplate5,
        PreDefineTemplate6,
      ];
      const Component = preDefined[template.template - 1];
      return (
        Component && (
          <Component
            heading={template.media_caption}
            caption={template.tagline}
            date={template.posted_at}
            journalId={template.id}
            pageRefresh={pageRefresh}
            ref={ref}
            menuShow={false}
          />
        )
      );
    } else {
      if (template.media_url) {
        if (template?.media_type === "reel") {
          const VideoComponent = videoTemplates[index % videoTemplates.length];
          return (
            <VideoComponent
              heading={template.media_caption}
              caption={template.tagline}
              date={template.posted_at}
              media={template.media_url}
              journalId={template.id}
              pageRefresh={pageRefresh}
              phone={template?.phone}
              menuShow={true}
            />
          );
        } else {
          const ImageComponent = imageTemplates[index % imageTemplates.length];
          return (
            <ImageComponent
              heading={template.media_caption}
              caption={template.tagline}
              date={template.posted_at}
              media={template.media_url}
              journalId={template.id}
              pageRefresh={pageRefresh}
              ref={ref}
              menuShow={false}
            />
          );
        }
      } else {
        const TextComponent = textTemplates[index % textTemplates.length];
        return (
          <TextComponent
            heading={template.tagline}
            caption={template.media_caption}
            date={template.posted_at}
            journalId={template.id}
            pageRefresh={pageRefresh}
            ref={ref}
            menuShow={false}
          />
        );
      }
    }
  };

  // dnd-kit sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),

    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      const oldIndex = data.findIndex((item) => item.id === active.id);
      const newIndex = data.findIndex((item) => item.id === over?.id);
      const newData = arrayMove(data, oldIndex, newIndex); // New ordered array
      // setData(newData); // Update state

      const orderedIds = newData.map((item) => item.id);

      const payload = {
        phone: phone || user_phone,
        sequence: orderedIds,
      };
      if (sequenceData?.length <= 0 || sequenceCreation) {
        JournalAPIService.journalSequenctCreate(payload)
          .then((response) => {
            if (response) {
              setSequenceData(response);
              setSequenceId(response.id);
              setSequenceCreation(false);
            }
          })
          .catch((err) => {
            notifyError(
              err?.response?.data?.message ||
                API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
            );
          });
      } else {
        const payload = {
          sequence: orderedIds,
        };
        JournalAPIService.journalSequenctUpdate(sequenceId, payload)
          .then((response) => {
            if (response) {
              setSequenceData(response);
            }
          })
          .catch((err) => {
            notifyError(
              err?.response?.data?.message ||
                API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
            );
          });
      }
    }
  };

  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // Important if using CORS images
      img.onload = resolve;
      img.onerror = reject;
      img.src = url;
    });
  };

  const waitForImages = (container) => {
    const images = container.querySelectorAll("img");
    const promises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) return resolve();
          img.onload = img.onerror = resolve;
        })
    );
    return Promise.all(promises);
  };

  const wait = (ms) => new Promise((res) => setTimeout(res, ms));

  const convertSelectedTemplatesToImages = async (selectedIds) => {
    const images = [];

    for (const id of selectedIds) {
      const originalElement =
        templateRefs.current[id]?.current?.getCardElement();
      if (!originalElement) continue;

      const hasImageRenderBox =
        originalElement.querySelector(".imageRender") !== null;
      console.log("hasImageRenderBox", hasImageRenderBox);
      let canvas = null;
      let isSafari = false;
      // Clone the node
      if (hasImageRenderBox) {
        if (isRealSafari()) {
          isSafari = true;
        }

        let success = false;
        while (!success) {
          const clone = originalElement.cloneNode(true);

          if (isSafari) {
            clone.style.margin = "0px";
            clone.style.padding = "0px";
            clone.style.boxShadow = "none";
            clone.style.background = downloadJournal ? "transparent": "#FFFFFF";
            clone.style.borderRadius = "16px";
            // clone.style.marginLeft = "3px";
          }

          const rect = originalElement.getBoundingClientRect();
          // wrapper.setAttribute("data-download-wrapper", "true");
          const wrapper = document.createElement("div");
          wrapper.style.padding = isSafari
            ? "0px 0px 0px 4px"
            : "0px 0px 0px 4px";
          wrapper.style.transform = "none";
          wrapper.style.background = "transparent";
          wrapper.style.backgroundColor = "transparent";
          wrapper.style.display = "inline-block";
          wrapper.style.boxSizing = "content-box";
          wrapper.style.boxShadow = "none";
          wrapper.style.borderRadius = "16px";
          wrapper.style.width = `${rect.width}px`;
          // wrapper.style.height = `${rect.height}px`;
          // wrapper.style.width = "200px";
          // wrapper.style.height = "600px";
          // clone.style.transform = isSafari ? "translateX(-1px)" : "none";
          clone.style.background = isSafari ? downloadJournal ? "transparent" : "#FFFFFF" : "none";
          clone.style.boxShadow = "none";

          wrapper.appendChild(clone);
          document.body.appendChild(wrapper);

          await wait(600);
          await new Promise((r) => setTimeout(r, 800));

          // await document.fonts.ready;
          // await waitForImages(wrapper);

          canvas = await toPng(wrapper, {
            cacheBust: true,
            skipFonts: true,
            backgroundColor: downloadJournal?"transparent":"#FFFFFF",
            // pixelRatio: 2,
            style: {
              transform: "none",
              margin: "0",
              boxShadow: "none!important",
              borderRadius: "16px",
            },
            filter: (node) => node.className !== "no-screenshot",
          });

          const base64Length = canvas.length - "data:image/png;base64,".length;
          const sizeInBytes = Math.ceil((base64Length * 3) / 4);

          if (sizeInBytes < 80 * 1024) {
            // Retry if under 80KB
            wrapper.remove();
            continue;
          }

          const blob = await (await fetch(canvas)).blob();
          const file = new File([blob], `${id}.png`, { type: "image/png" });
          images.push(file);
          wrapper.remove();
          success = true;
        }
      } else {
        canvas = await html2canvas(originalElement, {
          useCORS: true,
          backgroundColor: "#FFFFFF",
          scale: 7, // optional: for better resolution
        });
        // Convert to File
        const blob = await new Promise((res) =>
          canvas.toBlob(res, "image/png")
        );
        const file = new File([blob], `${id}.png`, { type: "image/png" });
        images.push(file);
      }
    }

    return images;
  };

  const handleCreateVideo = async () => {
    setDownloadLoadingFlag(true);
    const selectedIds = Object.keys(selectedTemplates).filter(
      (id) => selectedTemplates[id]
    );
    if (selectedIds.length < 2) {
      notifyError("Please select at least 2 templates to create a video.");
      return;
    }
    const images = await convertSelectedTemplatesToImages(selectedIds);
    setVideoImageFiles(images);
    setDownloadLoadingFlag(false);
    setVideoModalOpen(true);
  };

  const handleDownloadAll = async () => {
    setDownloadLoadingFlag(true);
    const zip = new JSZip();

    try {
      const selectedIds = Object.keys(selectedTemplates).filter(
        (id) => selectedTemplates[id]
      );

      if (selectedIds.length === 0) {
        notifyError("Please select at least 1 template to download.");
        return;
      }

      for (const id of selectedIds) {
        const template = data.find((t) => t.id === id);
        const isVideo =
          /\.(mp4|webm|ogg|m4v|mov|avi|mkv|3gpp|3gp|3g2|hevc|h265)$/i.test(
            template?.media_url
          );

        const backgroundVideo = await fetch(template.media_url).then((res) =>
          res.blob()
        );

        if (template?.media_type === "reel") {
          // Assuming generateVideoWithoutOverlay returns a blob
          const videoBlob = await generateVideoWithoutOverlay(backgroundVideo);
          zip.file(`${id}.mp4`, videoBlob);
        } else {
          const element = templateRefs.current[id]?.current?.getCardElement();
          if (!element) continue;

          if (isVideo) {
          const canvas = await html2canvas(element, {
            useCORS: true,
            backgroundColor: "transparent",
            scale: 7,
          });

          const dataUrl = canvas.toDataURL("image/png");
          const overlayBlob = await (await fetch(dataUrl)).blob();


            const finalVideoBlob = await generateVideoWithOverlay(
              overlayBlob,
              backgroundVideo
            );
            zip.file(`${id}.mp4`, finalVideoBlob);
          } else {
            const images = await convertSelectedTemplatesToImages([id]);
            zip.file(`${id}.png`, images[0]);
          }
        }
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "Memory_Journal.zip");

      setOpenInfo(true);
      notifySuccess(API_SUCCESS_MESSAGE.DOWNLOAD_REEL);
    } catch (error) {
      notifyError("Something went wrong while downloading images.");
      console.error("Download error:", error);
    } finally {
      setDownloadLoadingFlag(false);
    }
  };


  const generateVideoWithOverlay = async (overlayImage, backgroundVideo) => {
    try {
      if (!ffmpeg.loaded) await ffmpeg.load();

      const overlayArrayBuffer = await fetch(
        URL.createObjectURL(overlayImage)
      ).then((res) => res.arrayBuffer());
      const bgVideoArrayBuffer = await fetch(
        URL.createObjectURL(backgroundVideo)
      ).then((res) => res.arrayBuffer());

      await ffmpeg.writeFile("overlay.png", new Uint8Array(overlayArrayBuffer));
      await ffmpeg.writeFile(
        "background.mp4",
        new Uint8Array(bgVideoArrayBuffer)
      );

      await ffmpeg.exec([
        "-i",
        "background.mp4",
        "-i",
        "overlay.png",
        "-filter_complex",
        "[0:v]scale=480:500[vid];[1:v]scale=520:720[bg];[bg][vid]overlay=(W-w)/2:(H-h)/2-60",
        "-c:v",
        "libx264",
        "-pix_fmt",
        "yuv420p",
        "-preset",
        "ultrafast",
        "output_overlay.mp4",
      ]);

      const data = await ffmpeg.readFile("output_overlay.mp4");
    return new Blob([data.buffer], { type: "video/mp4" });

      // const data = await ffmpeg.readFile("output_overlay.mp4");
      // const url = URL.createObjectURL(
      //   new Blob([data.buffer], { type: "video/mp4" })
      // );

      // const a = document.createElement("a");
      // a.href = url;
      // a.download = "Joy_Memory.mp4";
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);

      // setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Error generating overlay video:", error);
      notifyError("Video generation failed.");
    }
  };

  const generateVideoWithoutOverlay = async (backgroundVideo) => {
    try {
      if (!ffmpeg.loaded) await ffmpeg.load();

      const bgVideoArrayBuffer = await fetch(
        URL.createObjectURL(backgroundVideo)
      ).then((res) => res.arrayBuffer());

      await ffmpeg.writeFile(
        "background.mp4",
        new Uint8Array(bgVideoArrayBuffer)
      );

      // FFmpeg: overlay PNG onto video
      await ffmpeg.exec([
        "-i",
        "background.mp4",
        "-filter_complex",
        "scale=520:720:flags=lanczos",
        "-c:v",
        "libx264",
        "-pix_fmt",
        "yuv420p",
        "-preset",
        "ultrafast",
        "output_overlay.mp4",
      ]);

      const data = await ffmpeg.readFile("output_overlay.mp4");
    return new Blob([data.buffer], { type: "video/mp4" });

      // const data = await ffmpeg.readFile("output_overlay.mp4");
      // const url = URL.createObjectURL(
      //   new Blob([data.buffer], { type: "video/mp4" })
      // );
      // Auto-download the file
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = "Joy_Memory.mp4";
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);

      // // Optional: Revoke the URL after some time to free memory
      // setTimeout(() => URL.revokeObjectURL(url), 1000);

      // setVideoUrl(url);
    } catch (error) {
      console.error("Error generating overlay video:", error);
    }
  };

  function downloadBlobAsFile(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <Container sx={{ padding: "4px" }}>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={data.map((d) => d.id)}
          strategy={rectSortingStrategy}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0,
              padding: 1,
              minHeight: 200,
            }}
          >
            {data.map((template, index) => {
              const isLast = index === data.length - 1;
              let isVideo =
                /\.(mp4|webm|ogg|m4v|mov|avi|mkv|3gpp|3gp|3g2|hevc|h265)$/i.test(
                  template?.media_url
                );
              const reelVideo = template?.media_type;
              if (!isVideo || downloadJournal) {
                return (
                  <SortableItem
                    key={template.id}
                    id={template.id}
                    video={isVideo}
                    reel={reelVideo}
                  >
                    <Box>
                      <Box position="relative">
                        <Box
                          position="absolute"
                          top={10}
                          left={10}
                          zIndex={1002}
                          bgcolor="#fff"
                          borderRadius={"50%"}
                        >
                          <Paper
                            elevation={2}
                            sx={{
                              position: "absolute",

                              zIndex: 1002,
                              bgcolor: "#fff",
                              borderRadius: "8px",
                              padding: "0px",
                            }}
                          >
                            <Checkbox
                              size="medium"
                              checked={!!selectedTemplates[template.id]}
                              onChange={() => {
                                setSelectedTemplates((prev) => ({
                                  ...prev,
                                  [template.id]: !prev[template.id],
                                }));
                              }}
                              sx={{
                                color: "#1976d2",
                                "&.Mui-checked": {
                                  color: "#1976d2",
                                },
                                padding: "2px",
                              }}
                            />
                          </Paper>
                        </Box>
                        {renderTemplateComponent(template, index)}
                      </Box>
                    </Box>
                  </SortableItem>
                );
              }
            })}
          </Box>
        </SortableContext>
      </DndContext>

      <DownloadBackdrop
        downloading={downloadLoadingFlag}
        text="Please wait.."
      />

      <Dialog
        maxWidth="md"
        fullScreen
        open={videoModalOpen}
        onClose={() => setVideoModalOpen(false)}
        sx={{ zIndex: 3100 }}
        TransitionProps={{
          onExited: () => (document.body.style.overflow = "unset"),
        }}
      >
        <VideoWithTransitions
          imageFiles={videoImageFiles}
          user_phone={phone || user_phone}
          onClose={() => {
            setVideoModalOpen(false);
            onClose();
          }}
        />
      </Dialog>

      <Box
        sx={{
          position: "fixed",
          bottom: 10,
          left: "50%", // center horizontally
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "center",
          zIndex: 2000,
        }}
      >
        <Button
          variant="contained"
          sx={{
            mt: 2,
            background: "#005cff",
            color: "#ffffff",
            px: { xs: 2, sm: 4 }, // horizontal padding (smaller on mobile)
            fontSize: { xs: "12px", sm: "14px" }, // responsive font size
            whiteSpace: "nowrap", // prevent wrapping
            textTransform: "none", // optional: keep original casing
          }}
          disabled={
            downloadJournal
              ? Object.keys(selectedTemplates).filter(
                  (id) => selectedTemplates[id]
                ).length < 1
              : Object.keys(selectedTemplates).filter(
                  (id) => selectedTemplates[id]
                ).length < 2
          }
          onClick={downloadJournal ? handleDownloadAll : handleCreateVideo}
        >
          {downloadJournal ? "Download" : "Create Reel from Selected Memories"}
        </Button>
      </Box>

      <Dialog
        open={openInfo}
        onClose={() => setOpenInfo(false)}
        sx={{ zIndex: 5000 }}
      >
        <DialogTitle>📥 Find Your Download!</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: "bold", mr: 1 }}>
              1.
            </Typography>
            <Typography variant="body2">
              Look for the Download Icon ⬇️ in your browser address bar
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: "bold", mr: 1 }}>
              2.
            </Typography>
            <Typography variant="body2">
              Tap the Icon to see a list of your recent downloads. 👉 Tap the
              downloaded file to open it, play it or save it to your photos
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: "bold", mr: 1 }}>
              3.
            </Typography>
            <Typography variant="body2">
              Don’t See the Icon? Tap the{" "}
              <img src={info1} width="25px" alt="Aa" loading="eager" /> or <img src={info2} width="25px" alt="download" loading="eager" />
              button in Safari’s address bar → Select “Show Downloads”
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenInfo(false)}
            variant="contained"
            sx={{ color: "#ffffff", background: "#005cff" }}
          >
            Got it!
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default MemorySelector;
